export default __webpack_public_path__ + "static/media/empty-user.aedb5262.svg";